import React from "react";

const Input = (props) => {

  return (
    <div className="inputContainer">
      {props.label && <label htmlFor={props.name}>{props.label}</label>}
      <input
        type={props.type}
        name={props.name}
        id={props.name}
        placeholder={props.placeholder}
        onChange={props.onChange}
        onBlur={props.onBlur}
        value={props.value}
        style={props.style}
      />
    </div>
  );
};

export default Input;
